'use client';

import ReactFlow, { Background, Controls } from 'reactflow';
import 'reactflow/dist/style.css';
import { Box, Typography } from '@mui/material';
import { ViewOnlyNode } from './ViewNode';
import '../../../organizationalcharts/organogram/styles/organogram.css';
import { useOrganogramContext } from './hooks/useOrganogramContext';
import { NodeModal } from './NodeModal';

const nodeTypes = {
    orgNode: ViewOnlyNode
};

export function ViewOnlyOrganogram() {
    const { nodes, edges } = useOrganogramContext();

    return (
        <Box className="view-only-flow-wrapper">
            <Box sx={{ height: '100%', position: 'relative' }}>
                <Box className="edit-mode-controls">
                    Clique no card para ver detalhes
                </Box>
                <ReactFlow
                    nodes={nodes}
                    edges={edges}
                    nodeTypes={nodeTypes}
                    fitView
                    fitViewOptions={{ padding: 0.2 }}
                    nodesDraggable={false}
                    nodesConnectable={false}
                    elementsSelectable={true}
                    zoomOnDoubleClick={false}
                    snapToGrid={true}
                    defaultEdgeOptions={{
                        type: 'default',
                        animated: true,
                        style: {
                            curvature: 0.2
                        },
                        markerEnd: {
                            type: 'arrowclosed',
                            width: 20,
                            height: 20
                        }
                    }}
                    snapGrid={[15, 15]}
                >
                    <Background />
                    <Controls showInteractive={false} />
                </ReactFlow>

                <NodeModal />
            </Box>
        </Box>
    );
}
